import { useMemo } from "react";
import { useCurrentProfile } from "@/hooks/useCurrentProfile";
import { getBrowserLocale, resolveLocaleContext } from "@/domain/locale/catalog";

export const useUserLocale = () => {
  const { profile, loadingProfile, profileError, reloadProfile } = useCurrentProfile();

  const localeContext = useMemo(
    () =>
      resolveLocaleContext({
        profileLocale: profile?.userLocale,
        profileCountry: profile?.profileCountry,
        organizationCountry: profile?.organizationCountry,
        organizationCurrency: profile?.organizationCurrency,
        browserLocale: getBrowserLocale(),
      }),
    [
      profile?.organizationCountry,
      profile?.organizationCurrency,
      profile?.profileCountry,
      profile?.userLocale,
    ],
  );

  return {
    ...localeContext,
    loadingProfile,
    profileError,
    reloadProfile,
    hasProfileLocale: Boolean(profile?.userLocale),
    hasProfileCountry: Boolean(profile?.profileCountry),
  };
};
